import { createElement } from "react";
import { Trans } from "react-i18next";
import { deleteHttp } from "../../../common/api/apiShared";
import { Result } from "../../../common/api/result";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { IDeletePurposeDialog } from "./DeletePurposeDialog";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function DeletePurposeDialogDataMapping(props: IDeletePurposeDialog) {
    const snackbar = useDotLegalSnackbar();

    const removeMutation = useDotLegalMutation(remove);
    const removePurpose = () => {
        removeMutation.mutateAsync(undefined, {
            onSuccess: (response: Result<string>) => {
                props.onCloseDialog();

                if (response.success()) {
                    props.onSaveCorrect();
                    snackbar.show(createElement(Trans, { i18nKey: "purposeDeleted", values: { name: props.selectedPurpose.name } }));
                } else {
                    snackbar.show(createElement(Trans, { i18nKey: "purposeNotDeleted", values: { name: props.selectedPurpose.name } }), "warning");
                }
            },
        });
    };

    async function remove() {
        return await deleteHttp<string>(`/purposes/${props.selectedPurpose.id}`);
    }

    return {
        removePurpose,
        inProgess: removeMutation.isLoading,
    };
}
